/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Card_FromInputs */

const en_api_card_from = /** @type {(inputs: Api_Card_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`from`)
};

const zh_hans1_api_card_from = /** @type {(inputs: Api_Card_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低至`)
};

const pt_br2_api_card_from = /** @type {(inputs: Api_Card_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a partir de`)
};

const es_api_card_from = /** @type {(inputs: Api_Card_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`desde`)
};

const fr_api_card_from = /** @type {(inputs: Api_Card_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`à partir de`)
};

const de_api_card_from = /** @type {(inputs: Api_Card_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ab`)
};

const ru_api_card_from = /** @type {(inputs: Api_Card_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`от`)
};

const it_api_card_from = /** @type {(inputs: Api_Card_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`da`)
};

/**
* | output |
* | --- |
* | "from" |
*
* @param {Api_Card_FromInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const api_card_from = /** @type {((inputs?: Api_Card_FromInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Card_FromInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_api_card_from(inputs)
	if (locale === "pt-BR") return pt_br2_api_card_from(inputs)
	if (locale === "es") return es_api_card_from(inputs)
	if (locale === "fr") return fr_api_card_from(inputs)
	if (locale === "de") return de_api_card_from(inputs)
	if (locale === "ru") return ru_api_card_from(inputs)
	if (locale === "it") return it_api_card_from(inputs)
	return en_api_card_from(inputs)
});